import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../constants/dataAids';

const Fetching = props => {
  const { fetching, pageTransition, transparentBackground } = props;
  if (!fetching) return null;
  const { Block, Loader } = UX2.Element;
  const styles = {
    outer: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      top: '-2px',
      right: '-2px',
      bottom: '-2px',
      left: '-2px',
      minHeight: '250px',
      backgroundColor: pageTransition && !transparentBackground ? 'section' : 'transparent'
    },
    loader: {
      marginTop: 'xlarge',
      fontColor: 'lowContrast',
      opacity: '0.5'
    }
  };

  return (
    <Block style={ styles.outer }>
      <Loader data-aid={ dataAids.SHOP_FETCHING_LOADER } fontSize='large' style={ styles.loader } />
    </Block>
  );
};

Fetching.propTypes = {
  fetching: PropTypes.bool,
  transparentBackground: PropTypes.bool,
  pageTransition: PropTypes.bool
};

export default Fetching;
